<template>
  <div class="d-flex align-center justify-center text-center">
    <div v-if="stringData !== undefined" class="text-end mr-n7">
      <p :style="`color: ${primaryColor}`" class="mb-0">{{ stringData.firstTitle }}</p>
      <h1 :style="`color: ${primaryColor}`">${{ new Intl.NumberFormat().format(Number(stringData.firstNumber.toFixed(2))) }}</h1>
      <p :style="`color: ${secondaryColor}`" class="mb-0 mt-2">{{ stringData.secondTitle }}</p>
      <h1 :style="`color: ${secondaryColor}`">${{ new Intl.NumberFormat().format(Number(stringData.secondNumber.toFixed(2))) }}</h1>
    </div>
    <apexchart class="mr-n9" v-if="height !== undefined && chartOptions !== undefined && series !== undefined"
               type="radialBar" :height="height" :options="chartOptions" :series="series"/>
  </div>
</template>

<script>
export default {
  name: "CircularChart",
  props: {
    stringData: Object,
    height: Number,
    series: Array,
    primaryColor: String,
    secondaryColor: String,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 250,
          type: 'radialBar',
        },
        colors: ['#00a553'],
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            dataLabels: {
              showOn: "always",
              name: { show: false },
              value: {
                show: true,
                fontSize: '140px',
                offsetY: 5,
                color: '#FFFFFF',
                formatter: function (val) {
                  return val.toFixed(1) + '%'
                }
              },
            }
          },
        },
      }
    };
  },
  watch: {
    height() {
      this.updateChart();
    },
    series() {
      this.updateChart();
    },
    primaryColor() {
      this.updateChart();
    },
    stringData() {
      this.updateChart();
    }
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      this.chartOptions = {
        chart: {
          height: this.height,
          type: 'radialBar',
        },
        colors: [this.primaryColor],
        stroke: { lineCap: 'round' },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            dataLabels: {
              showOn: "always",
              name: { show: false },
              value: {
                show: true,
                fontSize: "140px",
                offsetY: 5,
                color: this.secondaryColor,
                formatter: function (val) {
                  return `${val.toFixed(1)}%`;
                }
              },
              style: {
                fontSize: "140px",
              },
            }
          },
        },
      };
    },
  }
}
</script>

<i18n>
{
  "en": {
  },
  "es": {
    "reachedLabel": "Alcanzado"
  }
}
</i18n>

<style scoped>

</style>
